import React from "react";

import { encodeSearchTerms } from "@cayuse/shared-react.utils.helpers";
import { executeRequest } from "@cayuse/shared-react.utils.http";

import { ADMINISTRATION_AD_HOC_TEAM_URL } from "globals/constants";


export const searchTeams = searchText => {
	const escapeValue = value => value.replace(/(\,|\*|\")/gi, "\\$1");
	const searchTerms = [ { key: "name", val: `*${escapeValue(searchText.toLocaleLowerCase()).trim()}*` } ];

	const search = encodeSearchTerms(searchTerms);

	const url = `${ADMINISTRATION_AD_HOC_TEAM_URL}?page=0&size=20&fields=name,id&sort=name,ASC&search=*${search}*`;

	return executeRequest(url)
		.then(response => {
			const options = (response._embedded.adhocteams ?? []).map(team => {
				return {
					key: team.id,
					value: team.id,
					text: team.name,
					team: team,
					content: (
						<div className="optionContent">
							<span>{team.name}</span>
						</div>
					),
				};
			});

			return { options, hiddenOptionsCount: response.page.totalPages > 1 && response.page.totalElements - response._embedded?.adhocteams.length };
		});
};
